import React from "react";

const LoginContent = () => {
  return <div>LoginContent</div>;
};

export default LoginContent;
